import Vue from "vue";
import TranslationService from "../../../ceres/services/TranslationService";
import ModalService from "../../../ceres/services/ModalService";
const ApiService = require("../../../ceres/services/ApiService");

export default Vue.component("order-history-list-item", {
	props: {
		template: {
			type: String,
			default: "#vue-order-history-list-item"
		},
		orderDetailsTemplate: {
			type: String,
			default: "Eros::MyAccount.Partials.OrderHistoryListItemDetails"
		},
		order: {
			type: Object,
			required: true
		},
		allowPaymentProviderChange: {
			type: Boolean,
			default: true
		},
		allowReturn: {
			type: Boolean,
			default: true
		}
	},

	data() {
		return {
			waiting: false,
			isDataLoaded: false,
			showAllOrderItems: false,
			trackingNumber: "",
			orderTrackingModal: {}
		};
	},

	mounted() {
		this.$nextTick(() => {
			this.orderTrackingModal = ModalService.findModal(this.$refs.orderTrackingModal);
		});
	},

	computed: {
		trackingModalBody() {
			return TranslationService.translate("Eros::Template.myAccountTrackingModalBody", {
				paketNr: this.trackingNumber
			});
		}
	},

	methods: {
		loadOrderDetailTemplate() {
			if (!this.waiting && !this.isDataLoaded) {
				this.waiting = true;

                const testing = window.ceresEnv !== "testing" ? "" : "&env=testing";

				ApiService.get(
					"/rest/io/order/template?template=" + this.orderDetailsTemplate + "&orderId=" + this.order.id + testing
				)
					.done(orderDetails => {
						const compiled = Vue.compile(orderDetails);
						const component = new Vue({
							data: {
								showAllOrderItems: this.showAllOrderItems,
								allowPaymentProviderChange: this.allowPaymentProviderChange,
								allowReturn: this.allowReturn
							},
							store: window.ceresStore,
							render: compiled.render,
							staticRenderFns: compiled.staticRenderFns
						});

						component.$mount(this.$refs.orderDetailsContainer);

						this.isDataLoaded = true;
					})
					.always(() => {
						this.waiting = true;
					});
			}
		},

		getWarrantyTooltip(referenceOrderId) {
			return TranslationService.translate("Ceres::Template.orderHistoryWarranty", { id: referenceOrderId });
		},

		showTrackingModal(trackingURL) {
			this.trackingNumber = trackingURL.replace("modal#", "");
			this.orderTrackingModal.show();
		}
	}
});
